import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Assignment from 'react-icons/lib/md/assignment';

import { Card } from 'react/card/Card';
import CardTitle from 'react/card/CardTitle';
import { OverviewFooter } from 'react/card/OverviewFooter';
import PreformattedModal from 'react/views/generic/PreformattedModal';
import TrackedLink from "react/views/generic/TrackedLink";
import ContentTitle from 'react/views/generic/ContentTitle';
import Icon from "react/views/generic/Icon";

import './insideThisBook.less';

class InsideThisBook extends Component {
	constructor(props) {
		super(props);
		this.state = {isModalOpen: false}
		this.onModalOpen = this.onModalOpen.bind(this);
		this.onModalClose = this.onModalClose.bind(this);
	}

	onModalOpen(item) {
		this.setState({isModalOpen: true, modalContent: {name: item.name, __html: item.body}});
	}

	onModalClose() {
        this.setState({isModalOpen: false});
	}

	renderItems(items, loggingId) {
		return (
			<ul id="inside-book-list" className="inside-book-list">
				{items && items.map((item, index) => {
					return (
						<TrackedLink featureType={item.featureType} destId={item.id} srcId={loggingId} key={index}>
							<li className="clickable" onClick={() => this.onModalOpen(item)}>
								{item.name}
							</li>
						</TrackedLink>
					);
				})}
			</ul>
		);
	}

	renderCardContent(items, loggingId) {
		return (
			<div className="inside-book">
				<Icon icon={Assignment} color="rgba(47,85,151,1)" />
				<ContentTitle>Sneak a peek:</ContentTitle>
				{this.renderItems(items, loggingId)}
			</div>
		);
	}

	render() {
		const {cardName, cardModel, loggingId} = this.props;
		return (
			<Card>
				<CardTitle title={cardName} />
				{this.renderCardContent(cardModel, loggingId)}
				<PreformattedModal
					item={this.state.modalContent}
					isOpen={this.state.isModalOpen}
					onClose={this.onModalClose}
					modalStyle={{ "padding": "15px" }}/>
				<OverviewFooter/>
			</Card>
		);
	}
}

InsideThisBook.propTypes = {
	cardName: PropTypes.string,
	cardModel: PropTypes.arrayOf(PropTypes.object),
	loggindId: PropTypes.number
}

export default InsideThisBook;



// WEBPACK FOOTER //
// ./src/react/views/insideThisBook/InsideThisBook.jsx